export default function UseCases() {
  const cases = [
    {
      icon: '🧾',
      title: 'Fakturahåndtering',
      desc: 'PDF fakturaer konverteres automatisk til struktureret data og valideres direkte i ERP.',
    },
    {
      icon: '📊',
      title: 'Dataimport fra Excel',
      desc: 'Excel filer behandles og importeres automatisk – uden manuel indgriben.',
    },
    {
      icon: '🔗',
      title: 'Dokumentvalidering på tværs',
      desc: 'Valider data på tværs af flere systemer og sikr konsistens i hele organisationen.',
    },
    {
      icon: '⚙️',
      title: 'Automatisering af manuelle workflows',
      desc: 'Erstat tidskrævende manuelle processer med et fuldt automatiseret dokumentflow.',
    },
  ];

  return (
    <section className="py-24 px-6 md:px-12 border-b border-border relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 reveal">
          <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground block mb-4">
            06 / USE CASES
          </span>
          <h2 className="text-4xl md:text-6xl text-foreground tracking-tight font-serif font-light mb-4">
            Typiske kunder bruger Dataflowsuite til
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {cases?.map((item, i) => (
            <div
              key={i}
              className={`p-8 border border-border rounded-xl bg-card flex items-start gap-6 hover:border-primary/30 transition-colors reveal delay-${(i + 1) * 100}`}
            >
              <div className="text-4xl flex-shrink-0">{item?.icon}</div>
              <div>
                <h3 className="text-xl text-foreground font-medium mb-2">{item?.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{item?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
